import React from "react";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import { AuthContext } from "../../auth/authContext";
import {
  reporteCobranzaRangoFecha,
  reporteCobranzaSerie,
  reporteResumenSerie,
  reporteVentasMantenimientoPorFechaAPI,
  reporteVentasPrevisionPorFechaAPI,
} from "../../API/ApiReportes";

import DataTable from "react-data-table-component";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { LoadingComponent } from "../../Components/LoadingComponent/LoadingComponent";
import { checkPermisosPorUsuarioPorGuidPantalla } from "../../API/ApiPermisos";
import { SinPermisoComponent } from "../../Components/SinPermisoComponent/SinPermisoComponent";
import MultiselectSeriesComponent from "../../Components/MultiselectSeriesComponent/MultiselectSeriesComponent";
import { toast } from "react-toastify";
import ReactToPrint from "react-to-print";
import imageVitanova from "../../Images/LogotipoNegro.png";

import imagenVitaNova from "../../Images/LogotipoNegro.png";
import { ButtonDownloadToXlsComponent } from "../../Components/ButtonDownloadToXlsComponent/ButtonDownloadToXlsComponent";
import CambiarFormatoFechaHelper from "../../Helpers/CambiarFormatoFechaHelper";

const guidVista = "ef433e95-e3b0-4caa-a533-3b599add112e";

const columns = [
  {
    name: "Contrato",
    selector: (row) => (
      <>
        <a
          target="_self"
          rel="noreferrer"
          href={`/contrato/${row.idcontrato}/false`}
        >
          {row.noContrato}
        </a>
      </>
    ),
    sortable: true,
  },
  {
    name: "Fecha Pago",
    selector: (row) => CambiarFormatoFechaHelper(row.fechaPago),
    sortable: true,
  },
  {
    name: "Importe",
    selector: (row) =>
      "$ " +
      parseFloat(row.monto)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,"),
    sortable: true,
  },
  {
    name: "Folio",
    selector: (row) => row.folio,
    sortable: true,
  },

  {
    name: "Justificación",
    selector: (row) => row.justificacion,
    sortable: true,
  },
];

const ListToPrintComponent = React.forwardRef((props, ref) => {
  const { user, dispatch } = React.useContext(AuthContext);

  const [totalSalarios, setTotalSalarios] = React.useState(0.0);

  return (
    <div className="print-source " ref={ref}>
      <img
        alt="Vitanova Logo"
        className="mt-3"
        src={imageVitanova}
        width="150"
      />
      <br />

      <h3 className="mt-3">Reporte total ventas previsión por fecha</h3>
      <h6 className="mb-4">
        <small>Reporte general</small>
      </h6>
      <h6 className="mb-4">
        <small>
          de: {CambiarFormatoFechaHelper(props.fechaInicio)} a:{" "}
          {CambiarFormatoFechaHelper(props.fechaFin)}
        </small>
      </h6>

      <div className="container-fluid">
        <div className="row row-cols-5">
          <div className="col">
            <strong>Contrato</strong>
          </div>
          <div className="col">
            <strong>Fecha</strong>
          </div>
          <div className="col">
            <strong>Importe</strong>
          </div>
          <div className="col">
            <strong>Recibo</strong>
          </div>

          <div className="col">
            <strong>Justificación</strong>
          </div>
        </div>
      </div>
      {props.value.map((empleado, index) => (
        <div className="container-fluid" key={index}>
          <div className="row row-cols-5">
            <div className="col">{empleado.noContrato}</div>
            <div className="col">
              {CambiarFormatoFechaHelper(empleado.fechaPago)}
            </div>
            <div className="col">
              {"$ "}{" "}
              {parseFloat(empleado.monto)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </div>
            <div className="col">{empleado.folio}</div>

            <div className="col">{empleado.justificacion}</div>
          </div>
        </div>
      ))}
      <div className="container-fluid">
        <div className="row row-cols-5">
          <div className="col">
            <strong>Total:</strong>
          </div>
          <div className="col"></div>
          <div className="col">
            {"$ "}{" "}
            {parseFloat(props.granTotalImporteTotal)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
          </div>

          <div className="col"></div>
        </div>
      </div>
      <br />
    </div>
  );
});

const ComponentToPrint = React.forwardRef((props, ref) => {
  const { user, dispatch } = React.useContext(AuthContext);

  return (
    <div className="print-source " ref={ref}>
      <img alt="Vitanova Logo" src={imageVitanova} width="150" />
      <br />
      <br />
      <br />
      <h3>Reporte total mantenimiento</h3>
      <br />
      <strong>
        {" "}
        de: {CambiarFormatoFechaHelper(props.fechaInicio)} a:{" "}
        {CambiarFormatoFechaHelper(props.fechaFin)}
      </strong>
      <br />
      <br />
      <table className="table">
        <tbody>
          <tr>
            <td>Contrato</td>
            <td>{props.value.noContrato}</td>
          </tr>
          <tr>
            <td>Fecha Pago</td>
            <td>{CambiarFormatoFechaHelper(props.value.fechaPago)}</td>
          </tr>
          <tr>
            <td>Importe</td>
            <td>
              {" "}
              {"$ "}
              {parseFloat(props.value.monto)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </td>
          </tr>
          <tr>
            <td>folio</td>
            <td>
              {" "}
              {"$ "}
              {parseFloat(props.value.folio)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </td>
          </tr>
          <tr>
            <td>Descuento</td>
            <td>
              {" "}
              {"$ "}
              {parseFloat(props.value.descuento)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </td>
          </tr>
          <tr>
            <td>Justificación</td>
            <td>{props.value.justificacion}</td>
          </tr>
        </tbody>
      </table>
      <br />
      <br />
      <br />
      <br />
      __________________________________________________________________
      <br />
      Firma
      <br />
      <br />
      <small style={{ fontSize: "10px" }}>Impreso por: {user.username}</small>
    </div>
  );
});

const ComponentToPrintWrapper = (props) => {
  const componentRef = React.useRef();

  return (
    <TableRow
      sx={{
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell align="center">
        <a
          target="_self"
          rel="noreferrer"
          href={`/contrato/${props.item.idcontrato}/false`}
        >
          {props.item.noContrato}
        </a>
      </TableCell>
      <TableCell align="center">
        {CambiarFormatoFechaHelper(props.item.fechaPago)}
      </TableCell>
      <TableCell align="center">
        {"$ "}
        {parseFloat(props.item.monto)
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
      </TableCell>
      <TableCell align="center">{props.item.folio}</TableCell>

      <TableCell align="center">
        {""} {props.item.justificacion}
      </TableCell>

      <TableCell align="center" className="d-none">
        {" "}
        <ReactToPrint
          trigger={() => (
            <button type="primary" className="btn btn-sm btn-success">
              Imprimir Recibo
            </button>
          )}
          content={() => componentRef.current}
        />
        <ComponentToPrint
          ref={componentRef}
          value={props.item}
          fechaInicio={props.fechaInicio}
          fechaFin={props.fechaFin}
          granTotalImporteTotal={props.granTotalImporteTotal}
          granTotalPagadoTotal={props.granTotalPagadoTotal}
          granTotalSaldoTotal={props.granTotalSaldoTotal}
        />
      </TableCell>
    </TableRow>
  );
};

export const ReporteMantenimientoScreenComponent = () => {
  const componentRefListado = React.useRef();

  const todayInicio = new Date();
  const todayFin = new Date();
  const numberOfDaysToAdd = 15;
  const dateInicio = todayInicio.setDate(
    todayInicio.getDate() - numberOfDaysToAdd
  );
  const dateFin = todayFin.setDate(todayFin.getDate());

  const defaultValueInicio = new Date(dateInicio).toISOString().split("T")[0]; // yyyy-mm-dd

  const defaultValueFin = new Date(dateFin).toISOString().split("T")[0]; // yyyy-mm-dd

  const { user, dispatch } = React.useContext(AuthContext);
  const [reporteSerie, setReporteSerie] = React.useState("");
  const [reporteFechaInicial, setReporteFechaInicial] =
    React.useState(defaultValueInicio);
  const [reporteFechaFin, setReporteFechaFin] = React.useState(defaultValueFin);
  const [finalData, setFinalData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [checkPersmissions, setCheckPermissions] = React.useState([]);
  const [permisoParaVisualizar, setPermisoParaVisualizar] =
    React.useState(false);
  const [permisoReporte, setPermisoReporte] = React.useState(false);
  const [seriesSeleccionadas, setSeriesSeleccionadas] = React.useState([]);
  const [granTotalComisionMostrar, setGranTotalComisionMostrar] =
    React.useState(0.0);

  const [granTotalTotalMostrar, setGranTotalTotalMostrar] = React.useState(0.0);

  const [listoParaMandar, setListoParaMandar] = React.useState(false);

  const [granTotalImporteTotal, setGranTotalImporteTotal] = React.useState(0.0);
  const [granTotalPagadoTotal, setGranTotalPagadoTotal] = React.useState(0.0);
  const [granTotalSaldoTotal, setGranTotalSaldoTotal] = React.useState(0.0);

  React.useEffect(() => {
    let listo = false;

    let granTotalImporte = 0.0;
    let granTotalPagado = 0.0;
    let granTotalSaldo = 0.0;

    for (const registro of finalData) {
      granTotalImporte = granTotalImporte + parseFloat(registro.monto);
      granTotalPagado = granTotalPagado + parseFloat(registro.pagado);
      granTotalSaldo = granTotalSaldo + parseFloat(registro.saldoContrato);
    }

    setGranTotalImporteTotal(granTotalImporte);

    return () => {
      listo = true;
    };
  }, [finalData]);

  React.useEffect(() => {
    let ready = false;

    checkPermisosPorUsuarioPorGuidPantalla(user, guidVista).then(
      (resultado) => {
        if (resultado.status == 200) {
          setCheckPermissions(resultado.data);

          for (const permiso of resultado.data) {
            if (
              permiso.guidFuncion == "cae70f2e-1548-499c-80af-d3686adac988" &&
              permiso.allowed == 1
            ) {
              setPermisoParaVisualizar(true);
              setPermisoReporte(true);
            }
          }
        }
      }
    );

    let listo = false;

    let granTotalComision = 0.0;
    let granTotaltotal = 0.0;

    setGranTotalTotalMostrar(granTotaltotal);
    setGranTotalComisionMostrar(granTotalComision);
    return () => {
      listo = true;
    };
  }, []);

  return (
    <>
      {permisoParaVisualizar == true && permisoReporte == true ? (
        <>
          <div className="container-fluid mb-2 d-none d-print-block">
            <div className="row">
              <div className="col-12">
                <img src={imagenVitaNova} alt="Logo Vita Nova" height={30} />
              </div>
            </div>
          </div>
          <div className="container-fluid mb-3 mt-2">
            <div className="row row-cols-md-3 d-flex align-items-center">
              <div className="col">
                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  id="outlined-basic"
                  label="Fecha Inicio"
                  type="date"
                  variant="standard"
                  value={reporteFechaInicial}
                  onChange={(e) => {
                    setReporteFechaInicial(e.target.value);
                  }}
                />
              </div>
              <div className="col">
                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  id="outlined-basic"
                  label="Fecha Fin"
                  type="date"
                  variant="standard"
                  value={reporteFechaFin}
                  onChange={(e) => {
                    setReporteFechaFin(e.target.value);
                  }}
                />
              </div>
              <div className="col d-print-none">
                <button
                  disabled={listoParaMandar}
                  className="btn btn-sm btn-success w-100"
                  onClick={() => {
                    setLoading(true);
                    reporteVentasMantenimientoPorFechaAPI(user, {
                      fechaInicio: reporteFechaInicial,
                      fechaFin: reporteFechaFin,
                    }).then((resultado) => {
                      if (resultado.status == 200) {
                        setFinalData(resultado.data);
                      }
                      setLoading(false);
                    });
                  }}
                >
                  {" "}
                  Buscar{" "}
                </button>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <ReactToPrint
                  trigger={() => (
                    <button className="btn btn-sm btn-info my-3">
                      Imprimir Reporte General
                    </button>
                  )}
                  content={() => componentRefListado.current}
                />
                <ListToPrintComponent
                  ref={componentRefListado}
                  value={finalData}
                  fechaInicio={reporteFechaInicial}
                  fechaFin={reporteFechaFin}
                  granTotalImporteTotal={granTotalImporteTotal}
                  granTotalPagadoTotal={granTotalPagadoTotal}
                  granTotalSaldoTotal={granTotalSaldoTotal}
                />
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row row-cols-md-1">
              <div className="col" style={{ textAlign: "right" }}>
                <ButtonDownloadToXlsComponent
                  data={finalData}
                  fileName="Reporte de Mantenimiento"
                />
              </div>
            </div>
                      
          </div>

          <div className="container-fluid g-0 mt-3 mb-3">
            <div className="row row-cols-1">
              <div className="col-12">
                <div className="card">
                  <div className="card-body text-center">
                    {" "}
                    <strong> Total de importe </strong>
                    <br />
                    <small>
                      {" "}
                      {"$ "}{" "}
                      {granTotalImporteTotal
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="">
            <DataTable columns={columns} data={finalData} />
          </div>

          <div className="container-fluid g-0 mt-3">
            <div className="row row-cols-1">
              <div className="col-12">
                <div className="card">
                  <div className="card-body text-center">
                    {" "}
                    <strong> Total de importe </strong>
                    <br />
                    <small>
                      {" "}
                      {"$ "}{" "}
                      {granTotalImporteTotal
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {loading == true ? <LoadingComponent /> : null}
        </>
      ) : (
        <SinPermisoComponent />
      )}
    </>
  );
};
